<template>
  <section class="banner">
    <Image v-if="content.image" :source="content.image" class="banner__image" />
    <div class="banner__filter"></div>
    <div class="banner__content">
      <Icon id="texture" class="banner__icon" />
      <h1 class="title --hero" v-html="content.title"></h1>
      <p class="subtitle" v-html="content.subtitle"></p>
    </div>
  </section>
</template>

<script>
import Icon from '@/components/global/Icon.vue'
import Image from '@/components/global/Image.vue'

export default {
  name: 'Banner',
  components: { Icon, Image },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
